import {ModuleWithProviders, NgModule} from '@angular/core'
import {PossibilityHttp} from './http/possibility.http'
import {MessageService} from './service/message.service'
import {LoggerService} from './service/logger.service'
import {FormHttp} from './http/form.http'
import {SectionHttp} from './http/section.http'
import {QuestionHttp} from './http/question.http'
import {ProgressService} from './service/progress.service'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {HttpService} from './http/_.http-mock'
import {HttpClientModule} from '@angular/common/http'
import {ActiveService} from './service/active.service'
import {ConfigService} from './service/config.service'

const NG_MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
]

const HTTP = [
  HttpService,
  FormHttp,
  SectionHttp,
  QuestionHttp,
  PossibilityHttp,
]

const SERVICES = [
  ...HTTP,
  ProgressService,
  MessageService,
  LoggerService,
  ConfigService,
  ActiveService,
]

@NgModule({
  declarations: [],
  imports: [
    ...NG_MODULES,
  ],
  exports: [
    ...NG_MODULES
  ],
  providers: SERVICES,
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: SERVICES
    }
  }
}
